var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEnviagoLogoShort(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 60 60",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#2961FF",
    d: "M13.112 24.274h10.003v-.082c0-.766-.544-1.595-1.631-2.489-.997-.51-2.012-.765-3.044-.765-2.954 0-4.73 1.112-5.328 3.336zm5.001-11.595c7.63 0 12.486 3.974 14.57 11.922.362 1.514.544 3.382.544 5.606v.52H13.22v.11c.598 1.53 1.467 2.579 2.609 3.144 1.07.564 2.084.846 3.044.846h.381c1.269 0 2.483-.728 3.642-2.186h9.786v.11c-3.606 6.38-8.173 9.57-13.7 9.57-5.146 0-9.097-1.536-11.851-4.608C4.377 34.643 3 31.293 3 27.665c0-4.21 1.45-7.743 4.35-10.595 2.899-2.853 6.487-4.316 10.763-4.39z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEnviagoLogoShort);
export default __webpack_public_path__ + "static/media/enviago-logo-short.3cb04177.svg";
export { ForwardRef as ReactComponent };